'use es6';

const widgetsAlreadyLogged = [];
export function getWidgetElement($, widget, canUseGridLayoutGate) {
  let $widget;
  const widgetType = widget.type;
  let wrapperType = 'none';
  let parentSelector = '';

  // Count widgets contained in an element, by descendant data attributes and .hs_cos_wrapper classes.
  //
  // The renderer will mark elements which are the direct parent of unwrapped widgets with
  // data-hs-contains-widget=true - contains >= 1 unwrapped widgets, and
  // data-hs-contains-widget-myrichtextmodule1=1 - contains 1 widget with name myrichtextmodule1
  const _countWidgets = function _countWidgets($el) {
    const $widgets = $el.find('[data-hs-contains-widget]').addBack('[data-hs-contains-widget]');
    let childWidgetsByMarker = 0;
    for (let i = 0, len = $widgets.length; i < len; i++) {
      const currentWidget = $widgets[i];
      const data = $(currentWidget).data();
      childWidgetsByMarker += Object.keys(data).filter(k => {
        return k.indexOf('hsContainsWidget') > -1;
      }).filter(k => {
        return $.isNumeric(data[k]);
      }).reduce((memo, k) => {
        return memo + data[k]; // might be issues with kebab case props https://jquery.com/upgrade-guide/3.0/#breaking-change-data-names-containing-dashes
      }, 0);
    }
    const childWidgetsByWrapperClass = $el.find('.hs_cos_wrapper').addBack('.hs_cos_wrapper').length;
    return childWidgetsByMarker + childWidgetsByWrapperClass;
  };

  // TODO: Clean this up.
  if (widget.name) {
    $widget = $(`#hs_cos_wrapper_${widget.name}`);
    if (widget.name === 'name') {
      // special exception, support layouts where post_name is shown multiple places.  would not work except w/ SimpleTextEditor
      $widget = $(`[id='hs_cos_wrapper_${widget.name}']`);
    }
    if (widget.type === 'global_widget') {
      // Flex column/inpage
      $widget = $(`#hs_cos_wrapper_widget_${widget.key || widget.id}`);
      // Flex area
      if (!($widget.length > 0)) {
        $widget = $(`#hs_cos_wrapper_${widget.name}`);
      }
    }
    if ((widgetType === 'email_can_spam' || widgetType === 'email_view_as_web_page') && $(`[data-widget-type='${widget.type}']`).length // this only works with cmv1 modules but the first condition will work for cmv2 so skipping
    ) {
      $widget = $(`[data-widget-type='${widget.type}']`);
    }
    if ($widget.length) {
      wrapperType = 'wrapper';
    } else if (widget.name !== 'preview_text') {
      parentSelector = `body [data-hs-contains-widget-${widget.name}]`;
      $widget = $(`body [data-hs-contains-widget-${widget.name}]`);
      if ($widget.length) {
        wrapperType = _countWidgets($widget) > 1 ? 'sharedParent' : 'parent';
      }
    }
    // If we still haven't found the widget and we're on the grid layout gate,
    // then look for grid layout widgets
    if ($widget.length === 0 && canUseGridLayoutGate) {
      if (widget.type === 'dnd_area') {
        $widget = `[data-hs-grid-root-id="${widget.name}"]`;
      }
    }
    if (!$widget.length && !widget.export_to_template_context && widget.name !== 'preview_text' && !widgetsAlreadyLogged.includes(widget)) {
      widgetsAlreadyLogged.push(widget);
      console.warn('IPEUI: Widget not found in DOM', widget);
    }
  }
  // pretend we failed to find widgets which share a wrapper, for now
  if (wrapperType === 'sharedParent') {
    $widget = $([]);
  }
  return {
    $widget,
    wrapperType,
    parentSelector
  };
}
export function getWidgetElementImmutable($, widget) {
  let $widget;
  const widgetType = widget.get('type');
  const widgetName = widget.get('name');
  let wrapperType = 'none';
  let parentSelector = '';

  // Count widgets contained in an element, by descendant data attributes and .hs_cos_wrapper classes.
  //
  // The renderer will mark elements which are the direct parent of unwrapped widgets with
  // data-hs-contains-widget=true - contains >= 1 unwrapped widgets, and
  // data-hs-contains-widget-myrichtextmodule1=1 - contains 1 widget with name myrichtextmodule1
  const _countWidgets = function _countWidgets($el) {
    const $widgets = $el.find('[data-hs-contains-widget]').addBack('[data-hs-contains-widget]');
    let childWidgetsByMarker = 0;
    for (let i = 0, len = $widgets.length; i < len; i++) {
      const currentWidget = $widgets[i];
      const data = $(currentWidget).data();
      childWidgetsByMarker += Object.keys(data).filter(k => {
        return k.indexOf('hsContainsWidget') > -1;
      }).filter(k => {
        return $.isNumeric(data[k]);
      }).reduce((memo, k) => {
        return memo + data[k]; // might be issues with kebab case props https://jquery.com/upgrade-guide/3.0/#breaking-change-data-names-containing-dashes
      }, 0);
    }
    const childWidgetsByWrapperClass = $el.find('.hs_cos_wrapper').addBack('.hs_cos_wrapper').length;
    return childWidgetsByMarker + childWidgetsByWrapperClass;
  };

  // TODO: Clean this up.
  if (widgetName) {
    $widget = $(`#hs_cos_wrapper_${widgetName}`);
    if (widgetName === 'name') {
      // special exception, support layouts where post_name is shown multiple places.  would not work except w/ SimpleTextEditor
      $widget = $(`[id='hs_cos_wrapper_${widgetName}']`);
    }
    if (widgetType === 'global_widget') {
      // Flex column/inpage
      $widget = $(`#hs_cos_wrapper_widget_${widget.get('key') || widget.get('id')}`);
      // Flex area
      if (!($widget.length > 0)) {
        $widget = $(`#hs_cos_wrapper_${widgetName}`);
      }
    }
    if ((widgetType === 'email_can_spam' || widgetType === 'email_view_as_web_page') && $(`[data-widget-type='${widgetType}']`).length // this only works with cmv1 modules but the first condition will work for cmv2 so skipping
    ) {
      $widget = $(`[data-widget-type='${widgetType}']`);
    }
    if ($widget.length) {
      wrapperType = 'wrapper';
    } else if (widgetName !== 'preview_text') {
      parentSelector = `body [data-hs-contains-widget-${widgetName}]`;
      $widget = $(`body [data-hs-contains-widget-${widgetName}]`);
      if ($widget.length) {
        wrapperType = _countWidgets($widget) > 1 ? 'sharedParent' : 'parent';
      }
    }
    if (!$widget.length && !widget.get('export_to_template_context') && widgetName !== 'preview_text' && !widgetsAlreadyLogged.includes(widget)) {
      widgetsAlreadyLogged.push(widget);
      console.warn('IPEUI: Widget not found in DOM', widget);
    }
  }
  // pretend we failed to find widgets which share a wrapper, for now
  if (wrapperType === 'sharedParent') {
    $widget = $([]);
  }
  return {
    $widget,
    wrapperType,
    parentSelector
  };
}